export const SET_EMPLOYEE_GROUPS = 'SET_EMPLOYEE_GROUPS';
export const ADD_EMPLOYEE_GROUP = 'ADD_EMPLOYEE_GROUP';
export const UPDATE_EMPLOYEE_GROUP = 'UPDATE_EMPLOYEE_GROUP';
export const DELETE_EMPLOYEE_GROUP = 'DELETE_EMPLOYEE_GROUP';
export const SET_EMPLOYEE_GROUPS_LOADING = 'SET_EMPLOYEE_GROUPS_LOADING';
